import moment from 'moment'

const FLOOR_SCHEDULE_HOUR = 2

export function generateScheduleDate(date: string): string {
  return moment(date).add(FLOOR_SCHEDULE_HOUR, 'h').toISOString(true)
}
